import { isEmpty } from 'lodash';

import {
    REQUEST_GET_IBAN,
    SUCCESS_GET_IBAN,
    FAILURE_GET_IBAN,
    REQUEST_CREATE_IBAN,
    SUCCESS_CREATE_IBAN,
    FAILURE_CREATE_IBAN,
    REQUEST_DELETE_IBAN,
    SUCCESS_DELETE_IBAN,
    FAILURE_DELETE_IBAN,
    RESET_FORM_SUBMIT_UPDATE_IBAN,
    SET_TIMEOUT_ID,
    CLEAR_TIMEOUT_ID
} from './constants';
import {
    HTTP_METHOD_DELETE,
    HTTP_METHOD_GET,
    HTTP_METHOD_POST
} from '../../../constants/httpMethod';

import { makeActionCreator } from '../../../utils/actionsUtils';

import { CALL_API } from '../../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_UPDATE_IBAN);

export const setTimeoutId = makeActionCreator(SET_TIMEOUT_ID, 'timeoutId');
export const clearTimeoutId = makeActionCreator(CLEAR_TIMEOUT_ID);

const shouldFetchIban = state => {
    const ibans = state.account.iban.ibans;
    const fetching = state.account.myinterests.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(ibans)) {
        return true;
    } else {
        return false;
    }
};

export function fetchIbanIfNeeded(forceFetch = false) {
    return {
        [CALL_API]: {
            endpoint: '/user/iban',
            method: HTTP_METHOD_GET,
            types: [REQUEST_GET_IBAN, SUCCESS_GET_IBAN, FAILURE_GET_IBAN],
            shouldCallAPI: state => forceFetch || shouldFetchIban(state),
            authenticated: true
        }
    };
}

export function sendIbanCreateRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/iban',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [REQUEST_CREATE_IBAN, SUCCESS_CREATE_IBAN, FAILURE_CREATE_IBAN],
            authenticated: true,
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}

export function sendIbanDeleteRequest(ibanId, callback) {
    if (!ibanId || ibanId <= 0) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/iban',
            method: HTTP_METHOD_DELETE,
            body: { ibanId: ibanId },
            types: [REQUEST_DELETE_IBAN, SUCCESS_DELETE_IBAN, FAILURE_DELETE_IBAN],
            authenticated: true,
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/iban/actions.js